<div class="header-wrapper">
  <div class="header-bar flex style2023 flex-wrap">
    <div class="flex-shrink-1">
      <h1 class="page-header">Jobs Inbox</h1>
    </div>

    <div class="flex-grow-1 menu-container">
      <div class="menu-container-inner">
        <div class="burger">
          <i class="fa fa-caret-down"></i>
        </div>

        <div
          [hidden]="!showCombineTab"
          [class.selected]="selectedTab == inboxType_Combine"
          class="menu-item"
          (click)="chooseItem(inboxType_Combine)"
        >
          Combine
        </div>

        <div [class.selected]="selectedTab == 20" class="menu-item" (click)="chooseItem(20)">
          All Tasks
        </div>

        <div
          [class.selected]="selectedTab == inboxType_Deploy"
          class="menu-item"
          (click)="chooseItem(inboxType_Deploy)"
        >
          Job Deployment
          <span *ngIf="jobCounts && jobCounts?.deploymentCount > 0" class="eng-badge">{{
            jobCounts?.deploymentCount
          }}</span>
        </div>

        <!--        <div-->
        <!--          [class.selected]="selectedTab == inboxType_ExistingCapacity"-->
        <!--          class="menu-item"-->
        <!--          (click)="chooseItem(inboxType_ExistingCapacity)"-->
        <!--        >-->
        <!--          Existing Capacity-->
        <!--          <span *ngIf="jobCounts && jobCounts.existingCapacityCount > 0" class="eng-badge">{{-->
        <!--            jobCounts.existingCapacityCount-->
        <!--          }}</span>-->
        <!--        </div>-->

        <div
          [class.selected]="selectedTab == inboxType_AwaitingStart"
          class="menu-item"
          (click)="chooseItem(inboxType_AwaitingStart)"
        >
          Awaiting Start
          <span *ngIf="jobCounts && jobCounts.awaitingStartCount > 0" class="eng-badge">{{
            jobCounts.awaitingStartCount
          }}</span>
        </div>

        <div
          [class.selected]="selectedTab == inboxType_Live"
          class="menu-item"
          (click)="chooseItem(inboxType_Live)"
        >
          Live Now
          <span *ngIf="jobCounts && jobCounts.liveNowCount > 0" class="eng-badge">{{
            jobCounts.liveNowCount
          }}</span>
        </div>

        <div
          [class.selected]="selectedTab == inboxType_CompletedJobs"
          class="menu-item"
          (click)="chooseItem(inboxType_CompletedJobs)"
        >
          Completed Jobs
          <span *ngIf="jobCounts && jobCounts.completedCount > 0" class="eng-badge">{{
            jobCounts.completedCount
          }}</span>
        </div>

        <div
          [class.selected]="selectedTab == inboxType_JobsWaitingForApproval"
          class="menu-item"
          (click)="chooseItem(inboxType_JobsWaitingForApproval)"
        >
          Pending Additional Costs
          <span *ngIf="jobCounts && jobCounts.additionalCostsRequestsCount > 0" class="eng-badge">{{
            jobCounts.additionalCostsRequestsCount
          }}</span>
        </div>

        <div
          [class.selected]="selectedTab == inboxType_CancelledJobs"
          class="menu-item"
          (click)="chooseItem(inboxType_CancelledJobs)"
        >
          Cancelled
          <span *ngIf="jobCounts && jobCounts.cancelledCount > 0" class="eng-badge">{{
            jobCounts.cancelledCount
          }}</span>
        </div>

        <div
          [class.selected]="selectedTab == inboxType_ClosedJobs"
          class="menu-item"
          (click)="chooseItem(inboxType_ClosedJobs)"
        >
          Closed
          <span *ngIf="jobCounts && jobCounts.closedCount > 0" class="eng-badge">{{
            jobCounts.closedCount
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="body" style="padding: 5px">
  <div *ngIf="selectedTab == inboxType_Combine">
    <vme-jobs-grid
      #jobgrid
      [inboxType]="inboxType_Combine"
      [customers]="customers"
      [suppliers]="suppliers"
      (jobSelectionChanged)="jobSelectionChanged($event)"
      (onGridAction)="onGridAction($event)"
    >
    </vme-jobs-grid>
  </div>

  <div *ngIf="selectedTab == 20">
    <vme-jobs-faceted-filtering
      [inboxType]="inboxType_GlobalFilter"
      (jobSelectionChanged)="jobSelectionChanged($event)"
      (onGridAction)="onGridAction($event)"
    >
    </vme-jobs-faceted-filtering>
  </div>

  <div *ngIf="selectedTab == inboxType_Deploy">
    <vme-jobs-grid
      #jobgrid
      [inboxType]="inboxType_Deploy"
      [customers]="customers"
      [suppliers]="suppliers"
      (jobSelectionChanged)="jobSelectionChanged($event)"
      [stageId]="stageId"
      (totalCountChanged)="totalCountChanged(inboxType_Deploy, $event)"
      (onGridAction)="onGridAction($event)"
    >
    </vme-jobs-grid>
  </div>

  <!--  <div *ngIf="selectedTab == inboxType_ExistingCapacity">-->
  <!--    <vme-jobs-grid-->
  <!--      #jobgrid-->
  <!--      [inboxType]="inboxType_ExistingCapacity"-->
  <!--      [customers]="customers"-->
  <!--      [suppliers]="suppliers"-->
  <!--      (jobSelectionChanged)="jobSelectionChanged($event)"-->
  <!--      [stageId]="stageId"-->
  <!--      (totalCountChanged)="totalCountChanged(inboxType_ExistingCapacity, $event)"-->
  <!--      (onGridAction)="onGridAction($event)"-->
  <!--    >-->
  <!--    </vme-jobs-grid>-->
  <!--  </div>-->

  <div *ngIf="selectedTab == inboxType_AwaitingStart">
    <vme-jobs-grid
      #jobgrid
      [inboxType]="inboxType_AwaitingStart"
      [customers]="customers"
      [suppliers]="suppliers"
      (jobSelectionChanged)="jobSelectionChanged($event)"
      (totalCountChanged)="totalCountChanged(inboxType_AwaitingStart, $event)"
      (onGridAction)="onGridAction($event)"
    >
    </vme-jobs-grid>
  </div>

  <div *ngIf="selectedTab == inboxType_Live">
    <vme-jobs-tasks
      [inboxType]="liveTasks_InboxType_VME"
      [customers]="customers"
      [suppliers]="suppliers"
      (totalCountChanged)="totalCountChanged(inboxType_Live, $event)"
      (selectedTaskChange)="onTaskChanged($event)"
    >
    </vme-jobs-tasks>
  </div>

  <div *ngIf="selectedTab == inboxType_CompletedJobs">
    <vme-jobs-grid
      #jobgrid
      [inboxType]="inboxType_CompletedJobs"
      [customers]="customers"
      [suppliers]="suppliers"
      (jobSelectionChanged)="jobSelectionChanged($event)"
      (totalCountChanged)="totalCountChanged(inboxType_CompletedJobs, $event)"
      (onGridAction)="onGridAction($event)"
    >
    </vme-jobs-grid>
  </div>

  <div *ngIf="selectedTab == inboxType_JobsWaitingForApproval">
    <vme-jobs-waiting-approval
      #jobwaitingforapproval
      [inboxType]="inboxType_JobsWaitingForApproval"
      (jobSelectionChanged)="jobSelectionChanged($event)"
      (totalCountChanged)="totalCountChanged(inboxType_JobsWaitingForApproval, $event)"
      (onGridAction)="onGridAction($event)"
    >
    </vme-jobs-waiting-approval>
  </div>

  <div *ngIf="selectedTab == inboxType_CancelledJobs">
    <vme-jobs-grid
      #jobgrid
      [inboxType]="inboxType_CancelledJobs"
      [customers]="customers"
      [suppliers]="suppliers"
      (jobSelectionChanged)="jobSelectionChanged($event)"
      (onGridAction)="onGridAction($event)"
    >
    </vme-jobs-grid>
  </div>

  <div *ngIf="selectedTab == inboxType_ClosedJobs">
    <vme-jobs-grid
      #jobgrid
      [inboxType]="inboxType_ClosedJobs"
      [customers]="customers"
      [suppliers]="suppliers"
      (jobSelectionChanged)="jobSelectionChanged($event)"
      (onGridAction)="onGridAction($event)"
    >
    </vme-jobs-grid>
  </div>
</div>

<div class="ui-g" *ngIf="jobIsSelected && selecteditem != null">
  <div class="ui-g-12">
    <job-details
      [orgTypeId]="OrganisationTypeEnum.Engineius"
      [showTaskList]="true"
      [jobAndTask]="selecteditem"
      [showTaggingInfo]="true"
      [loadTaskFailures]="true"
    ></job-details>
  </div>
</div>

<!-- EC Matching component -->
<div class="ui-g" *ngIf="jobIsSelected && selectItemECJob != null">
  <div class="card job-details-container">
    <h2>Job Details {{ selectedItemEC.jobNumber }}</h2>
    <div *ngFor="let supplierJob of selectedItemEC.supplierECMatchJobs; let i = index">
      <ec-match-details
        [matchIndex]="i"
        [supplierJob]="supplierJob"
        [ecJob]="selectItemECJob"
      ></ec-match-details>
    </div>
  </div>
</div>

<div id="jobDetailsAnchor"></div>

<ng-template #loading>Loading...</ng-template>
